(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acko-home-hero"] && !Shopify.designMode) return;
  try {
    
const ackoHeroControllers = new WeakMap();
function initAckoHero(root) {
  if (ackoHeroControllers.has(root)) ackoHeroControllers.get(root)();
  const slides = Array.from(root.querySelectorAll('[data-slide]'));
  const tabs = Array.from(root.querySelectorAll('.ar-hero-tabs [data-target]'));
  const toggle = root.querySelector('[data-autoplay-toggle]');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const events = new AbortController();
  let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
  let paused = motion.matches;
  let hovering = false;
  let timer;
  const stop = () => { window.clearInterval(timer); timer = undefined; };
  const show = index => {
    active = index;
    slides.forEach((slide, position) => { slide.hidden = position !== active; });
    tabs.forEach((tab, position) => tab.setAttribute('aria-pressed', String(position === active)));
  };
  const sync = () => {
    stop();
    toggle.hidden = motion.matches;
    toggle.textContent = paused ? '▶ PLAY' : 'Ⅱ PAUSE';
    toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    if (!paused && !motion.matches && !document.hidden && slides.length > 1) {
      timer = window.setInterval(() => show((active + 1) % slides.length), 6000);
    }
  };
  tabs.forEach((tab, index) => tab.addEventListener('click', () => { show(index); sync(); }, { signal: events.signal }));
  toggle.addEventListener('click', () => { paused = !paused; sync(); }, { signal: events.signal });
  root.addEventListener('focusin', event => { if (event.target !== toggle && event.target.matches(':focus-visible')) { paused = true; sync(); } }, { signal: events.signal });
  document.addEventListener('visibilitychange', sync, { signal: events.signal });
  const motionChanged = () => { paused = motion.matches; sync(); };
  motion.addEventListener('change', motionChanged);
  ackoHeroControllers.set(root, () => { stop(); events.abort(); motion.removeEventListener('change', motionChanged); ackoHeroControllers.delete(root); });
  sync();
}
document.querySelectorAll('.ar-hero').forEach(initAckoHero);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ar-hero').forEach(initAckoHero));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.ar-hero').forEach(root => { if (ackoHeroControllers.has(root)) ackoHeroControllers.get(root)(); }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
